/* eslint-disable import/prefer-default-export */
export function get(key: string, defaultValue: any | null = null) {
  const value = localStorage.getItem(key);
  return value ? JSON.parse(value) : defaultValue;
}

export function set(key: string, value: any) {
  localStorage.setItem(key, JSON.stringify(value));
}
